<pr-icon-chip
  matTooltipPosition="above"
  fontSet="material-symbols"
  [icon]="icon()"
  [matTooltip]="label()"
>
  <ng-content />
</pr-icon-chip>
